import { createContext, type ReactNode, useContext, useMemo } from "react";
import type { Access, PlanOffer } from "./auth-api";
import { buildPlanGate, INACTIVE_PLAN_GATE, type PlanGate } from "./plan-gate";

const PlanGateContext = createContext<PlanGate>(INACTIVE_PLAN_GATE);

interface PlanGateProviderProps {
  access: Access | null;
  plans: readonly PlanOffer[];
  children: ReactNode;
}

/**
 * Тариф и его ограничения для экранов под каркасом. Через контекст, а не
 * пропсами: замок нужен карточке, таблице, подробностям и трём экранам, и
 * пробрасывать через их промежуточные уровни значит менять пол-экрана.
 */
export function PlanGateProvider({ access, plans, children }: PlanGateProviderProps) {
  const gate = useMemo(() => buildPlanGate(access, plans), [access, plans]);
  return <PlanGateContext.Provider value={gate}>{children}</PlanGateContext.Provider>;
}

export function usePlanGate(): PlanGate {
  return useContext(PlanGateContext);
}
